import React, { useState } from 'react';
import { api } from '../lib/api.js';

const PATHS = { invoice: 'invoices', credit_note: 'credit-notes' };

/**
 * "Keyed into Tally by hand": for a document the agent will not post, because
 * posting is off for the entity or the job gave up. Until it is marked, the
 * goods stay deducted from stock on top of Tally's own figure.
 */
export default function MarkInTally({ docType, id, onDone, compact = false }) {
  const [open, setOpen] = useState(false);
  const [voucher, setVoucher] = useState('');
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState(null);

  const save = async () => {
    setBusy(true); setError(null);
    try {
      await api.post(`/api/sync/${PATHS[docType]}/${id}/entered-in-tally`,
        voucher.trim() ? { voucher_ref: voucher.trim() } : {});
      setOpen(false);
      if (onDone) onDone();
    } catch (e) { setError(e.message); } finally { setBusy(false); }
  };

  if (!open) {
    return (
      <button className={`btn secondary${compact ? ' small' : ''}`} onClick={() => setOpen(true)}>
        Entered in Tally by hand
      </button>
    );
  }
  return (
    <span className="inline" style={{ gap: 6 }}>
      <input style={{ width: 150 }} value={voucher} placeholder="Tally voucher no."
        aria-label="Tally voucher number" onChange={(e) => setVoucher(e.target.value)} />
      <button className={`btn${compact ? ' small' : ''}`} disabled={busy} onClick={save}>{busy ? 'Saving…' : 'Confirm'}</button>
      <button className={`btn ghost${compact ? ' small' : ''}`} onClick={() => setOpen(false)}>Cancel</button>
      {error && <span className="sub" style={{ color: 'var(--critical-text)' }} role="alert">{error}</span>}
    </span>
  );
}
